import { MediaText } from 'editor/src/store/design/types';
import dissolveLoneSharedTextField from 'editor/src/store/design/util/dissolveLoneSharedTextField';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import type { RootState } from 'editor/src/store/index';

import updateMediaElementOperation, { MediaUpdateActionName } from './updateMediaElementOperation';

/**
 * Takes the shared-field id off the one member left behind when `element`
 * leaves its group. A no-op when the group still has partners, or had none.
 */
const dissolveLoneSharedTextFieldOperation =
  (element: MediaText) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    const lone = dissolveLoneSharedTextField(getState().design.designData, element, element.uuid);
    if (!lone) {
      return;
    }

    dispatch(
      updateMediaElementOperation(
        lone.address,
        { extra: { ...lone.element.extra, sharedFieldId: undefined } },
        MediaUpdateActionName.UNKNOWN,
        true,
      ),
    );
  };

export default dissolveLoneSharedTextFieldOperation;
